// extracted by mini-css-extract-plugin
export default {"otherPagesHero":"OtherPagesHero_otherPagesHero__Ghi3I","otherPagesHeroWrapper":"OtherPagesHero_otherPagesHeroWrapper__kCMI6","navbar":"OtherPagesHero_navbar__qo+EC"};